import React from 'react';
import ChevronDown from '@assets/icons/chevron-down';

interface ShowMoreDividerProps {
  onShowMore: () => void;
}

const ShowMoreDivider = (props: ShowMoreDividerProps) => {
  return (
    <div className={'flex items-center'}>
      <div className={'flex-grow h-[1px] bg-neutral-notebook/50'}></div>
      <div
        className={
          'text-primary-apricot font-bold leading-4 px-1 cursor-pointer'
        }
        onClick={props.onShowMore}
      >
        <span className={'underline'}>Show more</span>
        <ChevronDown
          className={'fill-current inline text-primary-apricot ml-1 w-3.5'}
        />
      </div>
      <div className={'flex-grow h-[1px] bg-neutral-notebook/50'}></div>
    </div>
  );
};

export default ShowMoreDivider;
